import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg'

export const CloseMenuButton = ({ setIsOpen }) => {
  return (
    <button aria-label='Close navigation menu' onClick={() => setIsOpen(false)}>
      <CloseIcon className='w-7 text-primary-300' />
    </button>
  )
}
